var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkRadioButtonGroup, UitkRadioButton } from 'uitk-react-radio-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';
import { useStores } from '../../../utils/hooks';
import { getSelectedFieldValue, radioFilterClickHandler } from './filter-helper';
export var Radio = observer(function (_a) {
  var _b;
  var inDialog = _a.inDialog,
    field = _a.field;
  var _c = useStores(),
    analytics = _c.analytics,
    activitySearchStore = _c.activitySearchStore;
  var location = useLocation();
  var history = useHistory();
  var selectedFieldValue = getSelectedFieldValue(field, activitySearchStore);
  var radioClickHandler = function (event) {
    var _a, _b, _c;
    activitySearchStore.searchSetup();
    var _d = __read(event.target.id.split('-'), 2),
      fieldId = _d[0],
      fieldVal = _d[1];
    var targetOption = (_a = field.options) === null || _a === void 0 ? void 0 : _a.find(function (option) {
      return option.value === fieldVal;
    });
    analytics.trackEvent((_b = targetOption === null || targetOption === void 0 ? void 0 : targetOption.selectAnalytics) === null || _b === void 0 ? void 0 : _b.referrerId, (_c = targetOption === null || targetOption === void 0 ? void 0 : targetOption.selectAnalytics) === null || _c === void 0 ? void 0 : _c.linkName);
    radioFilterClickHandler(fieldId, fieldVal, activitySearchStore, history, location, inDialog);
  };
  return React.createElement(React.Fragment, null, field.primary && React.createElement(UitkSpacing, {
    padding: {
      blockstart: 'four',
      blockend: 'two'
    }
  }, React.createElement(UitkHeading, {
    size: 6,
    "data-testid": 'filter--name'
  }, field.primary)), React.createElement(UitkRadioButtonGroup, {
    group: field.primary || '',
    selected: selectedFieldValue,
    onChange: radioClickHandler
  }, (_b = field === null || field === void 0 ? void 0 : field.options) === null || _b === void 0 ? void 0 : _b.map(function (option) {
    return React.createElement("div", {
      key: "parent-category-".concat(option.value),
      "data-testid": "".concat(option.id, "--radio--").concat(option.value)
    }, React.createElement(UitkRadioButton, {
      key: "radio-".concat(option.value),
      id: "".concat(option.id, "-").concat(option.value),
      name: option.id,
      label: option.primary,
      value: option.value,
      labelClassName: "uitk-type-300"
    }));
  })));
});